<template>
  <PageLayout>
    <div class="text-right pb-14">
      <span class="navy--text">Máte potíže?</span>
      <router-link to="/" class="link link-underline navy--text ml-2"
        >Pomoc</router-link
      >
    </div>

    <h2 class="text-h3 navy--text text--darken-1 font-weight-bold pb-2">
      Personalizace Adveroo
    </h2>
    <p class="body-2 navy--text text--darken-1 pb-6">
      Pro ještě lepší služby, prosím odpovězte na následujících pár otázek
    </p>

    <v-row>
      <v-col :lg="12" class="pt-0"> </v-col>
    </v-row>

    <template #footer>
      <v-row>
        <v-col>
          <v-btn color="white" class="c-btn" @click="goBack" min-width="186">
            Zpět
          </v-btn>
        </v-col>

        <v-col class="text-right">
          <v-btn
            color="primary"
            class="c-btn"
            min-width="186"
            @click="$router.push('/connect/additional-info')"
          >
            Pokračovat
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from "@/components/page/onboard/PageLayout"

export default {
  name: "ChooseAccount",
  components: {
    PageLayout,
  },
  data() {
    return {
      subsDuration: "year",
      subcription: null,
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
  },
}
</script>
